export function isSmallDevice() {
  return window.matchMedia( '(max-width: 979px)').matches;
}
